module.exports = __webpack_public_path__ + "assets/img/hero.fe5b235a.webp";